import useInboxState from '@modules/InboxModule/hooks/useInboxState';
import StateView from './StateView';

const InboxPanel = () => {
  const state = useInboxState();
  return <StateView state={state} />;
};

export default InboxPanel;
